import { render, staticRenderFns } from "./PeiHistory.vue?vue&type=template&id=802289a8&scoped=true"
import script from "./PeiHistory.vue?vue&type=script&lang=js"
export * from "./PeiHistory.vue?vue&type=script&lang=js"
import style0 from "./PeiHistory.vue?vue&type=style&index=0&id=802289a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802289a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('802289a8')) {
      api.createRecord('802289a8', component.options)
    } else {
      api.reload('802289a8', component.options)
    }
    module.hot.accept("./PeiHistory.vue?vue&type=template&id=802289a8&scoped=true", function () {
      api.rerender('802289a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/components/record/PeiHistory.vue"
export default component.exports